import Image from "@tiptap/extension-image";
import { ReactNodeViewRenderer } from "@tiptap/react";
import ImageNodeView from "./ImageNodeView";

const ResizableImage = Image.extend({
  name: "image",
  inline() {
    return true;
  },

  group() {
    return "inline";
  },
  draggable: true,

  addAttributes() {
  return {
    ...this.parent?.(),

    src: {
      default: null,

      parseHTML: (element) =>
        element.getAttribute("src"),

      renderHTML: (attributes) => {
        if (!attributes.src) return {};

        return {
          src: attributes.src,
        };
      },
    },

    caption: {
      default: "",
    },

    rotation: {
      default: 0,

      parseHTML: (element) => {
        return parseInt(
          element.getAttribute("data-rotation") || "0",
          10
        );
      },

      renderHTML: (attributes) => ({
        "data-rotation": attributes.rotation,
      }),
    },

    width: {
      default: "800px",

      parseHTML: (element) => {
        return (
          element.getAttribute("width") ||
          element.style.width ||
          "800px"
        );
      },

      renderHTML: (attributes) => ({
        width: attributes.width,
      }),
    },

    height: {
      default: "auto",

      parseHTML: (element) => {
        return (
          element.getAttribute("height") ||
          element.style.height ||
          "auto"
        );
      },

      renderHTML: (attributes) => ({
        height: attributes.height,
      }),
    },

    alignment: {
      default: "left",

      parseHTML: (element) => {
        return (
          element.getAttribute("data-alignment") ||
          "left"
        );
      },

      renderHTML: (attributes) => {
        const alignment = attributes.alignment || "left";

        return {
          "data-alignment": alignment,
        };
      },
    },
  };
},

  addNodeView() {
    return ReactNodeViewRenderer(ImageNodeView);
  },
});

export default ResizableImage;